<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center pb-4">
        <b-select rounded v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="500">500 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>

        <vs-dropdown>
          <vs-button
            class="btn-drop"
            color="#5b3cc4"
            type="filled"
            icon="touch_app"
            >Column</vs-button
          >

          <vs-dropdown-menu>
            <vs-dropdown-group vs-label="Column">
              <vs-dropdown-item @click="showCol">Show/Hide</vs-dropdown-item>
            </vs-dropdown-group>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          placeholder="Search"
          v-model="searchval"
          @keydown.enter="goSearch"
        />

        <div v-if="colshow" class="mt-4">
          <div
            v-for="(column, index) in columnsTemplate"
            :key="index"
            class="control"
          >
            <b-checkbox v-model="column.visible">{{ column.title }}</b-checkbox>
          </div>
        </div>

        <b-table
          id="grid-table"
          class="w-full mt-4"
          :data="data"
          :loading="loading"
          :striped="isStriped"
          :narrowed="isNarrowed"
          :hoverable="isHoverable"
          :selected.sync="selected"
          paginated
          backend-pagination
          :total="total"
          :per-page="perPage"
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          backend-sorting
          :default-sort-direction="defaultSortOrder"
          :default-sort="[sortField, sortOrder]"
          @sort="onSort"
          :sticky-header="stickyHeaders"
          height="500px"
        >
          <template slot="bottom-left">
            <h3>Total : {{ total }}</h3>
          </template>

          <b-input
            class="w-full"
            slot="searchable"
            slot-scope="props"
            v-model="props.filters[props.column.field]"
            placeholder="Search..."
            size="is-small"
          />

          <template slot-scope="props">
            <b-table-column
              :field="columnsTemplate[0].field"
              :label="columnsTemplate[0].title"
              :visible="columnsTemplate[0].visible"
              sortable
              searchable
              centered
            >
              <span
                :class="[
                  'tag',
                  { 'is-warning': props.row.exbstatus == 'WAIT' },
                  { 'is-danger': props.row.exbstatus == 'OUTBOUND_WAIT' },
                  { 'is-success': props.row.exbstatus == 'OUTBOUND_COMPLETE' },
                ]"
              >
                {{ props.row.exbstatus }}
              </span>
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[1].field"
              :label="columnsTemplate[1].title"
              :visible="columnsTemplate[1].visible"
              sortable
              searchable
              >{{ props.row.exbordersNumber }}
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[2].field"
              :label="columnsTemplate[2].title"
              :visible="columnsTemplate[2].visible"
              sortable
              searchable
              centered
              >{{ props.row.itemnum }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[3].field"
              :label="columnsTemplate[3].title"
              :visible="columnsTemplate[3].visible"
              sortable
              searchable
              >{{ props.row.dclnumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[4].field"
              :label="columnsTemplate[4].title"
              :visible="columnsTemplate[4].visible"
              sortable
              searchable
              >{{ cvDate(props.row.repdate) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[5].field"
              :label="columnsTemplate[5].title"
              :visible="columnsTemplate[5].visible"
              sortable
              searchable
              >{{ props.row.mawb }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[6].field"
              :label="columnsTemplate[6].title"
              :visible="columnsTemplate[6].visible"
              sortable
              searchable
              >{{ props.row.hawb }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[7].field"
              :label="columnsTemplate[7].title"
              :visible="columnsTemplate[7].visible"
              sortable
              searchable
              centered
              >{{ props.row.inbordersNumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[8].field"
              :label="columnsTemplate[8].title"
              :visible="columnsTemplate[8].visible"
              sortable
              searchable
              >{{ props.row.inbitemnum }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[9].field"
              :label="columnsTemplate[9].title"
              :visible="columnsTemplate[9].visible"
              sortable
              searchable
              centered
            >
              <span
                :class="[
                  'tag',
                  { 'is-warning': props.row.inbstatus == 'OPEN' },
                  { 'is-danger': props.row.inbstatus == 'INBOUND_WAIT' },
                  { 'is-success': props.row.inbstatus == 'INBOUND_COMPLETE' },
                ]"
              >
                {{ props.row.inbstatus }}
              </span>
            </b-table-column>

            <b-table-column
              :field="columnsTemplate[10].field"
              :label="columnsTemplate[10].title"
              :visible="columnsTemplate[10].visible"
              sortable
              searchable
              centered
              >{{ formatnumber(props.row.itempck) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[11].field"
              :label="columnsTemplate[11].title"
              :visible="columnsTemplate[11].visible"
              sortable
              searchable
              centered
              >{{ props.row.packagesCode }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[12].field"
              :label="columnsTemplate[12].title"
              :visible="columnsTemplate[12].visible"
              sortable
              searchable
              centered
              >{{ formatnumber(props.row.itemgw) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[13].field"
              :label="columnsTemplate[13].title"
              :visible="columnsTemplate[13].visible"
              sortable
              searchable
              centered
              >{{ props.row.gwunit }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[14].field"
              :label="columnsTemplate[14].title"
              :visible="columnsTemplate[14].visible"
              sortable
              searchable
              >{{ props.row.edescription }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[15].field"
              :label="columnsTemplate[15].title"
              :visible="columnsTemplate[15].visible"
              sortable
              searchable
              centered
              >{{ props.row.tmotypes_code }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[16].field"
              :label="columnsTemplate[16].title"
              :visible="columnsTemplate[16].visible"
              sortable
              searchable
              centered
              >{{ cvDate(props.row.out_at) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[17].field"
              :label="columnsTemplate[17].title"
              :visible="columnsTemplate[17].visible"
              sortable
              searchable
              centered
              >{{
                props.row.confirmOutTime == null
                  ? "N/A"
                  : cvDateNotime(props.row.confirmOutDate) +
                    " " +
                    cvTime(props.row.confirmOutTime)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[18].field"
              :label="columnsTemplate[18].title"
              :visible="columnsTemplate[18].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCode }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[19].field"
              :label="columnsTemplate[19].title"
              :visible="columnsTemplate[19].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMS }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[20].field"
              :label="columnsTemplate[20].title"
              :visible="columnsTemplate[20].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resFDMS == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTime)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[21].field"
              :label="columnsTemplate[21].title"
              :visible="columnsTemplate[21].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCodeMtoOut }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[22].field"
              :label="columnsTemplate[22].title"
              :visible="columnsTemplate[22].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSMtoOut }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[23].field"
              :label="columnsTemplate[23].title"
              :visible="columnsTemplate[23].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resCodeMtoOut == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTimeMtoOut)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[24].field"
              :label="columnsTemplate[24].title"
              :visible="columnsTemplate[24].visible"
              sortable
              searchable
              centered
              >{{ cvDate(props.row.fdmsRegetPermit) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[25].field"
              :label="columnsTemplate[25].title"
              :visible="columnsTemplate[25].visible"
              sortable
              searchable
              centered
              >{{ cvDate(props.row.permitPrint) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[26].field"
              :label="columnsTemplate[26].title"
              :visible="columnsTemplate[26].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCodeInboundPermit }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[27].field"
              :label="columnsTemplate[27].title"
              :visible="columnsTemplate[27].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSInboundPermit }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[28].field"
              :label="columnsTemplate[28].title"
              :visible="columnsTemplate[28].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resCodeInboundPermit == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTimeInboundPermit)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[29].field"
              :label="columnsTemplate[29].title"
              :visible="columnsTemplate[29].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCodeZerostock }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[30].field"
              :label="columnsTemplate[30].title"
              :visible="columnsTemplate[30].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSZerostock }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[31].field"
              :label="columnsTemplate[31].title"
              :visible="columnsTemplate[31].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resCodeZerostock == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTimeZerostock)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[32].field"
              :label="columnsTemplate[32].title"
              :visible="columnsTemplate[32].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCodeRevoke }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[33].field"
              :label="columnsTemplate[33].title"
              :visible="columnsTemplate[33].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSRevoke }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[34].field"
              :label="columnsTemplate[34].title"
              :visible="columnsTemplate[34].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resCodeRevoke == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTimeRevoke)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[35].field"
              :label="columnsTemplate[35].title"
              :visible="columnsTemplate[35].visible"
              sortable
              searchable
              centered
              >{{ props.row.resCodeRestock }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[36].field"
              :label="columnsTemplate[36].title"
              :visible="columnsTemplate[36].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSRestock }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[37].field"
              :label="columnsTemplate[37].title"
              :visible="columnsTemplate[37].visible"
              sortable
              searchable
              centered
              >{{ props.row.resFDMSRestockRef }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[38].field"
              :label="columnsTemplate[38].title"
              :visible="columnsTemplate[38].visible"
              sortable
              searchable
              centered
              >{{
                props.row.resCodeRestock == null
                  ? "N/A"
                  : cvDate(props.row.resFDMSTimeRestock)
              }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[39].field"
              :label="columnsTemplate[39].title"
              :visible="columnsTemplate[39].visible"
              sortable
              searchable
              centered
              >{{ props.row.editor }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[40].field"
              :label="columnsTemplate[40].title"
              :visible="columnsTemplate[40].visible"
              sortable
              searchable
              centered
              >{{ cvDate(props.row.createdAt) }}</b-table-column
            >
          </template>
        </b-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      data: [],
      colshow: false,
      selected: null,
      total: 0,
      loading: false,
      isStriped: false,
      isHoverable: true,
      isNarrowed: false,
      stickyHeaders: true,
      sortField: "itemnum",
      sortOrder: "asc",
      defaultSortOrder: "asc",
      page: 1,
      perPage: 20,
      searchval: "",
      columnsTemplate: [
        { title: "Outbound Status", field: "exbstatus", visible: true },
        { title: "Outbound Number", field: "exbordersNumber", visible: true },
        { title: "Outbound Item", field: "itemnum", visible: true },
        {
          title: "Outbound Declaration No.",
          field: "dclnumber",
          visible: true,
        },
        { title: "ลงวันที่", field: "repdate", visible: true },
        { title: "MAWB", field: "mawb", visible: true },
        { title: "HAWB", field: "hawb", visible: true },
        { title: "Inbound Number", field: "inbordersNumber", visible: true },
        { title: "Inbound Item", field: "inbitemnum", visible: true },
        { title: "Inbound Status", field: "inbstatus", visible: true },
        { title: "Package", field: "itempck", visible: true },
        { title: "Package Unit", field: "packagesCode", visible: true },
        { title: "G/W", field: "itemgw", visible: true },
        { title: "G/W Unit", field: "gwunit", visible: true },
        { title: "Description", field: "edescription", visible: true },
        { title: "ประเภท", field: "tmotypes_code", visible: true },
        { title: "ShipAt", field: "out_at", visible: true },
        { title: "confirmOutDate", field: "confirmOutDate", visible: true },
        { title: "resCode", field: "resCode", visible: true },
        { title: "ตอบกลับ(Zone3-Other Port)", field: "resFDMS", visible: true },
        { title: "resFDMSTime", field: "resFDMSTime", visible: true },
        { title: "resCodeMtoOut", field: "resCodeMtoOut", visible: true },
        {
          title: "ตอบกลับ(MTO Confirm Out)",
          field: "resFDMSMtoOut",
          visible: true,
        },
        {
          title: "resFDMSTimeMtoOut",
          field: "resFDMSTimeMtoOut",
          visible: true,
        },
        { title: "fdmsRegetPermit", field: "fdmsRegetPermit", visible: true },
        { title: "permitPrint", field: "permitPrint", visible: true },
        {
          title: "resCodeInboundPermit",
          field: "resCodeInboundPermit",
          visible: true,
        },
        {
          title: "ตอบกลับ (Inbound Permit)",
          field: "resFDMSInboundPermit",
          visible: true,
        },
        {
          title: "resFDMSTimeInboundPermit",
          field: "resFDMSTimeInboundPermit",
          visible: true,
        },
        { title: "resCodeZerostock", field: "resCodeZerostock", visible: true },
        { title: "resFDMSZerostock", field: "resFDMSZerostock", visible: true },
        {
          title: "resFDMSTimeZerostock",
          field: "resFDMSTimeZerostock",
          visible: true,
        },
        { title: "resCodeRevoke", field: "resCodeRevoke", visible: true },
        {
          title: "ตอบกลับ (FDMS Revoke)",
          field: "resFDMSRevoke",
          visible: true,
        },
        {
          title: "resFDMSTimeRevoke",
          field: "resFDMSTimeRevoke",
          visible: true,
        },
        { title: "resCodeRestock", field: "resCodeRestock", visible: true },
        {
          title: "ตอบกลับ (FDMS Restock)",
          field: "resFDMSRestock",
          visible: true,
        },
        {
          title: "Inbound Ref",
          field: "resFDMSRestockRef",
          visible: true,
        },
        {
          title: "resFDMSTimeRestock",
          field: "resFDMSTimeRestock",
          visible: true,
        },
        { title: "Editor", field: "editor", visible: true },
        { title: "createdAt", field: "createdAt", visible: true },
      ],
      background: "#23d160 !important",
      color: "white !important",
    };
  },
  props: ["masrec", "companyGroupsCode"],
  methods: {
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDateNotime(date) {
      let d = new Date(date);
      let dformat = [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    cvTime(time) {
      let d = time;
      let dformat =
        d.substring(0, 2) + ":" + d.substring(2, 4) + ":" + d.substring(4, 6);
      return dformat;
    },
    showCol() {
      if (this.colshow == true) {
        this.colshow = false;
      } else {
        this.colshow = true;
      }
    },
    async getData() {
      // alert("Hi");
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(this.fromDate);
      this.loading = true;

      try {
        if (token) {
          const formData = {
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            page: this.page,
            perpage: this.perPage,
            searchval: this.searchval,
            companyGroupsCode: this.companyGroupsCode,
            params: this.masrec,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/findallFDMS`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data,
            });
          } else {
            this.loading = false;

            this.data = [];
            let currentTotal = response.data.total_results;
            if (response.data.total_results / this.perPage > 1000) {
              currentTotal = this.perPage * 1000;
            }
            this.total = currentTotal;

            response.data.data.forEach((item) => {
              this.data.push(item);
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    /*
     * Handle page-change event
     */
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
    /*
     * Handle sort event
     */
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.getData();
    },
    /*
     * Type style in relation to the value
     */
    type(value) {
      const number = parseFloat(value);
      if (number < 6) {
        return "is-danger";
      } else if (number >= 6 && number < 8) {
        return "is-warning";
      } else if (number >= 8) {
        return "is-success";
      }
    },
    // Format Number
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    // Search
    goSearch() {
      // console.log(this.searchval);
      this.getData();
    },
  },
  mounted() {
    // console.log(this.fromDate);
    this.getData();
    // setTimeout(() => {
    //     this.selected = this.data[1];
    // }, 500);
  },
  computed: {
    rowSelected() {
      return this.selected;
    },
    perPageChanged() {
      return this.perPage;
    },
    dbchanged() {
      return this.$store.state.reportgrid;
    },
  },
  watch: {
    rowSelected: function () {
      // console.log(this.selected);
      this.$emit("recsel", this.selected.number, this.selected.exbordersNumber);
    },
    perPageChanged: function () {
      this.getData();
    },
    dbchanged: function () {
      // console.log("dbchanged");
      this.getData();
    },
  },
};
</script>

<style>
#grid-table td {
  white-space: nowrap;
}
.is-sticky-column-one {
  background: #23d160 !important;
  color: white !important;
}
.is-sticky-column-two {
  background: #167df0 !important;
  color: white !important;
}
</style>
